import axios from "axios"
import * as actions from "../actions/lookupCode"
import { EMPLOYEE_RESTRICTIONS, LOBBYIST_STATUS, ANNUAL_RETURN_TYPE } from '../js/const'

export function getEmployeeRestrictions() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/lookupCode?codeType=${EMPLOYEE_RESTRICTIONS}`)
      .then((response) => {
        let employeeRestrictions = response.data ? response.data.$values : []
        dispatch(actions.getEmployeesRestrictions(employeeRestrictions))
      })
  }
}

export function getLobbyistStatuses() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/lookupCode?codeType=${LOBBYIST_STATUS}`)
      .then((response) => {
        let lobbyistStatuses = response.data ? response.data.$values : []
        dispatch(actions.getLobbyistStatuses(lobbyistStatuses))
      })
  }
}

export function getAnnualReturnTypes() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/lookupCode?codeType=${ANNUAL_RETURN_TYPE}`)
      .then((response) => {
        let annualReturnTypes = response.data ? response.data.$values : []
        dispatch(actions.getAnnualReturnTypes(annualReturnTypes))
      })
  }
}


// WEBPACK FOOTER //
// ./src/actionCreators/lookupCode.js